export const chatmate = {
  id: 11,
  title: "ChatMate",
  activityId: null,
  startDate: '2025-08-01',
  endDate: null,
  description: "Specialized AI agents for VS Code Copilot Chat. Each chatmate excels at specific development tasks, enhancing developer productivity through systematic debugging, code review, testing, and project management workflows.",
  categorizedSkills: {
    profession: [
      { name: "Software Development", weight: 1 },
      { name: "AI", weight: 0.9 },
      { name: "Developer Tools", weight: 1 },
      { name: "CLI Development", weight: 0.8 }
    ],
    language: [
      // Language skills will be automatically detected from GitHub repository
    ],
    tools: [
      { name: "GitHub Copilot", weight: 0.9 },
      { name: "VS Code Extensions", weight: 0.8 },
      { name: "CLI", weight: 0.9 },
      { name: "Homebrew", weight: 0.7 }
    ],
    lead: []
  },
  goal: "Enhance VS Code development workflow through specialized AI agents that excel at specific development tasks like systematic debugging, code review, testing, and project management",
  detailsFile: "chatmate.md", // Reference to markdown file
  metrics: [
    "5 specialized AI agents implemented",
    "3 releases published with continuous improvements",
    "Homebrew tap integration for easy distribution"
  ],
  role: "Founder",
  teamSize: "1",
  git: "https://github.com/jonassiebler/chatmate",
  link: "https://github.com/jonassiebler/chatmate",
  status: "live",
  isProfessional: false,
  isVisible: true
};
